import React from "react";
import Helmet from 'react-helmet'
import { Link } from "gatsby"
import { withPrefix } from 'gatsby'
import Layout from "../components/layout";

// Assets
// import ruptureMP4 from '../assets/video/earthquake-damage.mp4';
// import ruptureWEBM from '../assets/video/earthquake-damage.webm';
import rupturePoster from '../assets/video/earthquake-damage.jpg';
import map from '../assets/images/surface-rupture-map2.jpg';
// import ruptureOverhead from '../assets/images/rupture-overhead.jpg';

export default () => (
  <React.Fragment>
  <Layout>
    <Helmet>
      <title>Mapping Quakes</title>
      <body className="mapping" />
    </Helmet>
    <div className="section hero">
      <div className="wrap">
        <h1>Mapping Quakes</h1>
        <p>Geological mapping is drawing the contacts between different rock units on a topographic map. “In this case, we follow the surface rupture and record its trace with GPS,” Akçiz explains. “This will produce a map of the earthquake and will include information on how many faults were involved with the earthquake rupture, how wide the deformation zone was at each fault, and how much displacement of the surface occurred along the fault.”</p>
      </div>
    </div>

    {/* <div className="section">
      <div className="row">
        <div className="col-8">
          <h1>Mapping Quakes</h1>
          <p>Geological mapping is drawing the contacts between different rock units on a topographic map. “In this case, we follow the surface rupture and record its trace with GPS,” Akçiz explains. “This will produce a map of the earthquake and will include information of how many faults were involved with the earthquake rupture, how wide the deformation zone was at each fault, and how much displacement of the surface occurred along the fault.”</p>
        </div>
        <duv className="col-4">
          <img src={map} alt="Ridgecrest surface rupture map." />
        </duv>
      </div>
    </div> */}

    <div className="wrap why-map">
      <h2>Why Map</h2>
      <p>The extent of faulting and magnitudes of surface displacement are essential in understanding the earthquake and the distribution of the aftershocks, Akçiz notes:</p>
      
      <blockquote><p>“This information might also end up getting used to design structures, including homes and office buildings, to withstand the distributed cracking and expected shaking.”</p></blockquote>
    </div>
    <div className="wrap">
      <div className="caption">
        <img src={map} alt="Ridgecrest surface rupture map." />
        <p>General surface rupture based on field mapping and satellite data as of July 15, 2019. Ruptures from the magnitude 6.4 event trend northeast to southwest, and ruptures from the magnitude 7.1 event trend northwest to southeast. Circles indicate where scientists have visited the fault surface rupture. (Credit: USGS) </p>
      </div>
    </div>
    
    <div className="wrap">
      {/* <div className="inline-image float_right">
        <img src={ruptureOverhead} alt="student" />
      </div> */}
      <h2>What’s at Fault </h2>
      <p>One interesting observation Akçiz made in the field is that the main fault gets split into two to three faults once it meets the bedrock region. “Generally, faults are more focused within harder bedrock and distributed over areas with unconsolidated sediments. However, in this case, the more resistive bedrock region is where the deformation gets distributed. It is possible that pre-existing faults are responsible for this distribution.”</p>
    </div>
    <div className="wrap large">
      <video autoPlay="autoplay" loop muted="muted" poster={rupturePoster} title="Surface rupture">
        <source src="https://news.fullerton.edu/feature/seismic-shaking/static/video/earthquake-damage.webm" type="video/webm; codecs=vp9,vorbis" />
        <source src="https://news.fullerton.edu/feature/seismic-shaking/static/video/earthquake-damage.mp4" type="video/mp4" />
        <track kind="descriptions"  src={ withPrefix('/rupture.html') } />
      </video>
    </div>
    <div className="wrap with-media">
      <p>Akçiz also discovered that the south end of the rupture has a broad split, roughly 1 mile of distributed cracking. As a result, the rupture is distributed over hundreds of cracks that are not easy to map or record in displacement measurements.</p>
    </div>
    <div className="bottom-nav">
      <Link to="/" className="navBtn prev"><span>Go Back to</span>Introduction</Link>
      <Link to="/student/" className="navBtn next"><span>Continue Reading...</span>Student Geologist</Link>
    </div>

  </Layout>
  </React.Fragment>
);

